import {
  isInformationalActionType,
  isTodoActionCard,
  type DecodedActionCard,
} from '@littlebird/action-cards';

import type { ActionCard, FeedType } from '@littlebird/sdk';

export const feedTypeOfCard = ({
  card,
  decoded,
}: {
  card: Pick<ActionCard, 'actionType'>;
  decoded: DecodedActionCard;
}): FeedType => {
  if (decoded.feedType) return decoded.feedType;
  if (isTodoActionCard(decoded.content)) return 'todo';
  if (isInformationalActionType(card.actionType)) return 'update';
  return 'action';
};
